import React, { useEffect, useState } from "react";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { db, fns } from "../firebase";
import { useSession } from "../auth.jsx";
import { Eyebrow } from "../components/Bits.jsx";

export default function Hunt() {
  const s = useSession();
  const [pack, setPack] = useState(null);
  const [answers, setAnswers] = useState({});
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    if (!s.profile?.cohortId) return;
    const q = query(collection(db, "specimens_public"),
      where("cohortId", "==", s.profile.cohortId), where("kind", "==", "slophunt"));
    return onSnapshot(q, (snap) => setPack(snap.docs[0] ? { id: snap.docs[0].id, ...snap.docs[0].data() } : null));
  }, [s.profile?.cohortId]);

  const submit = async () => {
    setBusy(true); setMsg(null);
    try {
      const call = httpsCallable(fns, "scoreSlopHunt");
      const r = await call({ packId: pack.id, answers });
      setResult(r.data);
      if (r.data.repeat) setMsg("This was your recorded attempt from before — the score that counts. Practice all you like below.");
    } catch (e) { setMsg(e.message); }
    finally { setBusy(false); }
  };

  if (!pack) return (
    <div style={{ maxWidth: 760 }}>
      <Eyebrow>The Slop Hunt</Eyebrow>
      <h1 style={{ fontSize: 24, marginTop: 4 }}>No hunt is open yet</h1>
      <p style={{ color: "var(--graphite)" }}>Your faculty releases a fresh set each month. It appears here the moment it is approved.</p>
    </div>
  );

  const items = pack.payload.items;
  const done = Object.keys(answers).length;
  const resFor = (id) => result?.results?.find((r) => r.id === id);

  return (
    <div style={{ maxWidth: 800 }}>
      <Eyebrow>The Slop Hunt · monthly ritual</Eyebrow>
      <h1 style={{ fontSize: 24, marginTop: 4 }}>Twelve interfaces. Which had a designer?</h1>
      <p style={{ color: "var(--graphite)", maxWidth: "64ch" }}>
        Six are machine-default; six were directed by a human. Classify each from the description. One
        recorded attempt — the tells are revealed only after you commit, because that is when they teach.
      </p>

      {result && (
        <div className="card" style={{ margin: "14px 0", borderColor: result.score >= 9 ? "var(--verdigris)" : "var(--bronze)" }}>
          <Eyebrow>Your recorded score</Eyebrow>
          <div className="mono" style={{ fontSize: 28 }}>{result.score}/{result.total}</div>
          <p style={{ fontSize: 13, color: "var(--graphite)" }}>
            Cohorts typically start near chance and reach 80%+ by Month 3. Wherever you landed, the tells below are the lesson.
          </p>
        </div>
      )}

      {items.map((it, i) => {
        const r = resFor(it.id);
        return (
          <div key={it.id} className="card" style={{ marginTop: 10, borderColor: r ? (r.correct ? "var(--verdigris)" : "var(--madder)") : "var(--rule)" }}>
            <Eyebrow>#{i + 1}</Eyebrow>
            <p style={{ fontSize: 15, margin: "6px 0" }}>{it.description}</p>
            {!result ? (
              <div className="row" style={{ gap: 8 }}>
                {["machine", "human"].map((v) => (
                  <button key={v} className={`btn ${answers[it.id] === v ? "" : "ghost"}`}
                    onClick={() => setAnswers({ ...answers, [it.id]: v })}>{v}</button>
                ))}
              </div>
            ) : (
              <p style={{ fontSize: 13 }}>
                <strong className={r.correct ? "pass" : "fail"}>{r.correct ? "Correct" : "Missed"}</strong> — it was <strong>{r.actual}</strong>.{" "}
                <span style={{ color: "var(--graphite)" }}>Tells: {r.tells?.join(" · ")}</span>
              </p>
            )}
          </div>
        );
      })}

      {!result && (
        <button className="btn" style={{ marginTop: 14 }} disabled={done < items.length || busy} onClick={submit}>
          {busy ? "Scoring…" : done < items.length ? `${items.length - done} to classify` : "Commit my answers"}
        </button>
      )}
      {msg && <div className="card" style={{ marginTop: 12 }}>{msg}</div>}
    </div>
  );
}
